var map = {
	"./asset-hyperlink.json": 1112,
	"./blockquote.json": 1113,
	"./document.json": 1114,
	"./embedded-asset-block.json": 1115,
	"./embedded-entry-block.json": 1116,
	"./embedded-entry-inline.json": 1117,
	"./embedded-resource-block.json": 1118,
	"./embedded-resource-inline.json": 1119,
	"./entry-hyperlink.json": 1120,
	"./heading-1.json": 1121,
	"./heading-2.json": 1122,
	"./heading-3.json": 1123,
	"./heading-4.json": 1124,
	"./heading-5.json": 1125,
	"./heading-6.json": 1126,
	"./hr.json": 1127,
	"./hyperlink.json": 1128,
	"./list-item.json": 1129,
	"./ordered-list.json": 1130,
	"./paragraph.json": 1131,
	"./resource-hyperlink.json": 1132,
	"./table-cell.json": 1133,
	"./table-header-cell.json": 1134,
	"./table-row.json": 1135,
	"./table.json": 1136,
	"./text.json": 1137,
	"./unordered-list.json": 1138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1111;